var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketName(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7692 6.5H3.69231C3.30462 6.5 3 6.17 3 5.75C3 5.33 3.30462 5 3.69231 5H14.7692C15.1569 5 15.4615 5.33 15.4615 5.75C15.4615 6.17 15.1569 6.5 14.7692 6.5ZM20.3077 11H12C11.6123 11 11.3077 10.67 11.3077 10.25C11.3077 9.83 11.6123 9.5 12 9.5H20.3077C20.6954 9.5 21 9.83 21 10.25C21 10.67 20.6954 11 20.3077 11Z",
    fill: "#79808A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 20C8.33 20 8 19.7187 8 19.3607V6.63927C8 6.28128 8.33 6 8.75 6C9.17 6 9.5 6.28128 9.5 6.63927V19.3607C9.5 19.7187 9.17 20 8.75 20ZM16.25 20C15.83 20 15.5 19.7187 15.5 19.3607V10.4749C15.5 10.1169 15.83 9.83562 16.25 9.83562C16.67 9.83562 17 10.1169 17 10.4749V19.3607C17 19.7187 16.67 20 16.25 20Z",
    fill: "#79808A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketName);
export default __webpack_public_path__ + "static/media/ticket-name.c601bc06e7ffba6b04f2f74058d4877d.svg";
export { ForwardRef as ReactComponent };